export const formatIdWithTooltip = (id: string | undefined | null) => {
  if (!id) return { short: '', full: '' }

  const short =
    id.length > 6
      ? `...${id.slice(-6)}`
      : id

  return {
    short,
    full: id,
  }
}
